module.exports = __webpack_public_path__ + "img/Afghanistan.0630083c.png";